import React, { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { api, formatErr } from "@/lib/api";
import { CheckCircle2, Loader2, Sun, X } from "lucide-react";

export default function VerifyEmail() {
  const [params] = useSearchParams();
  const token = params.get("token");
  const [status, setStatus] = useState("verifying");
  const [error, setError] = useState("");

  useEffect(() => {
    if (!token) { setStatus("error"); setError("Token mancante"); return; }
    api.post("/auth/verify-email", { token }).then(() => setStatus("success")).catch((e) => { setStatus("error"); setError(formatErr(e)); });
  }, [token]);

  return (
    <div className="min-h-screen bg-solar-bg text-zinc-900 flex items-center justify-center p-6">
      <div className="bg-white border border-zinc-200/70 rounded-3xl p-10 max-w-md w-full text-center">
        <div className="w-12 h-12 mx-auto rounded-xl bg-zinc-900 flex items-center justify-center text-white mb-5"><Sun size={24}/></div>
        {status === "verifying" && (<><Loader2 className="mx-auto text-amber-600 animate-spin mb-3" size={32}/><h1 className="text-2xl font-bold">Verifica in corso…</h1></>)}
        {status === "success" && (<><CheckCircle2 className="mx-auto text-emerald-600 mb-3" size={48}/><h1 className="text-2xl font-bold">Email verificata!</h1><p className="text-zinc-500 mt-2 text-sm">Il tuo account è confermato.</p><Link to="/app/dashboard" className="mt-6 inline-block bg-zinc-900 text-white font-semibold rounded-xl px-6 py-3 text-sm">Vai alla dashboard</Link></>)}
        {status === "error" && (<><X className="mx-auto text-rose-400 mb-3" size={48}/><h1 className="text-2xl font-bold">Verifica non riuscita</h1><p className="text-zinc-500 mt-2 text-sm">{error}</p><Link to="/app/settings" className="mt-6 inline-block border border-zinc-200/70 rounded-xl px-6 py-3 text-sm">Torna alle impostazioni</Link></>)}
      </div>
    </div>
  );
}
